import React from "react";
import { Navigate, useOutlet } from "react-router-dom";
import { CheckTokenExpire } from "../components/utils/atuhen";
import { GetDataRefreshToken, GetDataToken, SetDataRefreshToken, SetDataToken } from "../components/utils/data-storage";
import authenService from "../services/authenService";

const MasterPageAuthNoMenu = () => {
    const outlet = useOutlet();
    const accessTokenData = GetDataToken();
    const refreshTokenData = GetDataRefreshToken();

    const GetRefreshToken = async (refreshToken) => {
        const rftData = await authenService.RefreshToken({ refresh_token: refreshToken });
        if(rftData !== undefined){
            if(rftData.data.is_success === true){
                SetDataToken(rftData.data.result.token.access_token);
                SetDataRefreshToken(rftData.data.result.token.refresh_token);
                return true;
            }
        }
        return false;
    };

    if(accessTokenData === "" || accessTokenData === null || typeof(accessTokenData) === "undefined"
    || refreshTokenData === "" || refreshTokenData === null || typeof(refreshTokenData) === "undefined"){
        return(
            <Navigate to="/login" replace />
        );
    }else{
    //Check Access Token Expire
        const accessTokenExpire = CheckTokenExpire(accessTokenData);
        if(accessTokenExpire === true){
                //Check Refresh Token Expire
                const refreshTokenExpire = CheckTokenExpire(refreshTokenData);
                if(refreshTokenExpire === true){
                return(
                    <Navigate to="/login" replace />
                );  
            }else{
                const isRefreshToken = GetRefreshToken(refreshTokenData);
                if(isRefreshToken === false){
                    return(
                    <Navigate to="/login" replace />
                    );  
                }
            }
        }
    }

    return (
        <React.Fragment>
            {outlet}
        </React.Fragment>
    );
};

export default MasterPageAuthNoMenu;